

export default function Deli() {
    return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-6">

          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-10">
            Deli
          </h2>

      {/* Image Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 max-w-5xl">
        <img
          src="/assets/deli1.jpg"
          alt="Person talking with deli employee"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
        <img
          src="/assets/deli2.jpg"
          alt="Deli Meats"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
        <img
          src="/assets/deli3.jpg"
          alt="Deli Slicer"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
      </div>

      {/* Description */}
      <div className="max-w-3xl text-center p-6">
        <p className="text-gray-700 text-lg leading-relaxed">
          Our Deli Department serves freshly sliced meats, cheeses, and prepared foods made with quality ingredients. Stop by for quick meals and everyday favorites.
        </p>
      </div>
   <div class="w-full h-px bg-gray-300 my-8"></div>

        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-10">
          Catering
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 max-w-5xl">
        <img
          src="https://t4.ftcdn.net/jpg/10/10/60/25/360_F_1010602581_iAVc94tWYQTxoA5Y8GCFaRBJl5e9V2GI.jpg"
          alt="Fresh catered foods"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
        <img
          src="https://images.pexels.com/photos/2291367/pexels-photo-2291367.jpeg?cs=srgb&dl=pexels-naimbic-2291367.jpg&fm=jpg"
          alt="Catered food event"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />

      </div>
       <div className="max-w-3xl text-center p-6">
        <p className="text-gray-700 text-lg leading-relaxed">
     From party platters to hearty meals, our catering menu has everything you need. Place your order today and let us handle the cooking.
        </p>
      </div>
        
    </div>
  );
}